import { useMutation, useQueryClient } from 'react-query';
import { TerminationService } from '@wealthlane/api-services/wealthlane-award-service';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';

const usePostAdjustAwardByAwardDetail = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setInitialData: (data: any) => void,
  initialData?: any,
  setCheckedValues?: (data: any) => void
): any => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        TerminationService.postApiAwardApiAppTerminationAdjustAwardByAwardDetail(payload)
      );
    },
    {
      onSuccess: (response, payload) => {
        if (response) {
          const updatedAwardDetails = initialData?.awardDetails?.map((item: any) => {
            if (item?.awardId === response?.[0]?.awardId) {
              return { ...item, ...response?.[0] };
            }
            return item;
          });

          toast.success(<ToastComponent label='Success' message={`Selected award adjusted.`} />);
          setInitialData({ ...initialData, awardDetails: updatedAwardDetails });
          setCheckedValues([]);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostAdjustAwardByAwardDetail;
